import PaperAirplaneIcon from "@heroicons/react/24/outline/PaperAirplaneIcon";
import BellAlertIcon from "@heroicons/react/24/solid/BellAlertIcon";
import GlobeAsiaAustraliaIcon from "@heroicons/react/24/solid/GlobeAsiaAustraliaIcon";
import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputBase from "@mui/material/InputBase";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import styled from "styled-components";
import Color from "../../../assets/colors";
import { FontSize } from "../../../assets/font";

// Grid Components //
export const JobAlertContainer = styling(Grid)((props) => ({
  background: `linear-gradient(275.78deg, rgba(242, 175, 41, 0.16) -51.84%, rgba(242, 125, 41, 0.28) -38.45%, rgba(242, 175, 41, 0.16) -18.6%, rgba(81, 42, 204, 0.24) 31.08%, rgba(53, 25, 141, 0.4) 100%),
  linear-gradient(0deg, #FFFFFF, #FFFFFF)`,
  borderRadius: "8px",
  minHeight: "56px",
  padding: "0px 24px",
  border: `1.5px solid ${Color.black}`,
  cursor: "pointer",

  "&:hover": {
    backgroundColor: Color.white,
    boxShadow: "0px 4px 0px 0px rgba(0,0,0,1)",
    border: `1.5px solid ${Color.black}`,
    transition: "box-shadow 0.2s ease-in-out",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "51px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "48px",
  },
}));

export const GlobalHireContainer = styling(Box)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.5rem",
  flexWrap: "nowrap",

  backgroundColor: "#F5E3B1",
  borderRadius: "0.5rem",
  minHeight: "56px",
  padding: "0px 24px",
  border: `1px solid ${Color.black}`,

  "&:hover": {
    transition: "border 0.15s ease-in-out",
    border: `2px solid ${Color.black}`,
  },

  "@media (max-width: 1279px)": {
    minHeight: "64px",
    padding: "0px 16px",
  },
}));

export const VisitorJobAlertContainer = styling(Grid)({
  background: `linear-gradient(275.78deg, rgba(242, 175, 41, 0.16) -51.84%, rgba(242, 125, 41, 0.28) -38.45%, rgba(242, 175, 41, 0.16) -18.6%, rgba(81, 42, 204, 0.24) 31.08%, rgba(53, 25, 141, 0.4) 100%),
  linear-gradient(0deg, #FFFFFF, #FFFFFF)`,
  borderRadius: "8px",
  marginY: "10px",
  minHeight: "56px",
  padding: "0 15px 0 15px",
  border: `1.5px solid ${Color.black}`,
  cursor: "pointer",
});

export const GridStyled = styling(Grid)({
  //
});

export const TextWrapper = styling(Grid)({
  width: "60%",
});

export const UnsubcribeContainer = styling(Grid)((props) => ({
  background: `linear-gradient(91.03deg, #170C39 -7.37%, #170C39 7.22%, #34226B 58.35%, #7237BE 87.03%, ${Color.warn} 107.34%)`,
  borderRadius: "8px",
  height: "70px",
  padding: "0px 24px",
  cursor: "pointer",
  color: Color.white,

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px 15px",
  },
}));

export const IconContainer = styling(Grid)({
  backgroundColor: Color.white,
  borderRadius: "100px",
  border: `2px solid ${Color.black}`,
  height: "40px",
  width: "146px",
  padding: "0 20px",
  cursor: "pointer",
});

export const InputStyled = styled(Grid)`
  && {
    border-radius: 8px;
    background-color: ${Color.white};
    display: flex;
    align-items: center;
    border: 2px solid ${Color.black};
    width: 100%;
    height: 36px;
  }
`;

// Typography Component //
export const AlertTypography = styling(Typography)((props) => ({
  fontWeight: "bold",
  fontSize: "15px",
  lineHeight: "20px",
  letterSpacing: "0.46px",
  textTransform: "capitalize",

  [props.theme.breakpoints.down("lg")]: {
    textTransform: "capitalize",
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },

  [props.theme.breakpoints.down("tabletL")]: {
    flexWrap: "wrap",
    maxWidth: "60%",
  },
}));

export const GlobalHireTypography = styling(Typography)((props) => ({
  fontSize: "0.875rem",
  lineHeight: "1.5rem",
  letterSpacing: "0.15px",
}));

export const LoggedInAlertTypography = styling(Typography)((props) => ({
  fontWeight: "500",
  fontSize: "15px",
  lineHeight: "20px",
  letterSpacing: "0.46px",
  textTransform: "uppercase",

  [props.theme.breakpoints.down("lg")]: {
    textTransform: "capitalize",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
}));

export const TextContainer = styling("span")((props) => ({
  textWrap: "nowrap",
}));

// Icon Component
export const BellIcon = styling(BellAlertIcon)({
  width: "27px",
  height: "27px",
});

export const CheckStyled = styling(CheckIcon)({
  color: Color.black,
  fontSize: "16px",
  fontWeight: "bold",
});

export const SendIconStyled = styling(PaperAirplaneIcon)({
  color: Color.white,
  width: "14px",
  height: "14px",
});

// Input Components //
export const InputBaseStyled = styled(InputBase)`
  && {
    width: 100%;
    padding-left: 10px;

    & .MuiInputBase-input {
      color: ${Color.black};
      font-size: ${FontSize.desktopCaption};
    }
  }
`;

export const InputAdornmentStyled = styling(InputAdornment)({
  padding: "4px",
});

// Icon Button Components //
export const IconButtonStyled = styling(IconButton)({
  borderRadius: "4px",
  marginTop: "4px",
  marginBottom: "4px",
  backgroundColor: Color.black,
  height: "28px",
  width: "34px",

  ":hover": {
    backgroundColor: Color.black,
  },
});

export const IconButtonStyle = styling(IconButton)({
  backgroundColor: Color.white,
  height: "26px",
  width: "26px",

  ":hover": {
    backgroundColor: Color.white,
  },
});

export const GlobalIcon = styling(GlobeAsiaAustraliaIcon)({
  height: "24px",
  width: "24px",
  minWidth: "24px",
});

// Button Component //
export const WhiteButton = styling(Button)({
  height: "18px",
  padding: "16px 9.5px",
  backgroundColor: Color.white,
  color: Color.black,
  border: `2px solid ${Color.black}`,
  borderRadius: "0.5rem",
  textTransform: "none",

  ":hover": {
    backgroundColor: Color.white,
    color: Color.black,
  },
});

export const GlobalHireLink = styling("span")({
  color: Color.hiredlyPurple,
  fontSize: "0.875rem",
  fontWeight: "700",
  lineHeight: "1.5rem",
  letterSpacing: "0.15px",
  textDecoration: "underline",
  cursor: "pointer",
  paddingLeft: "0.25rem",
});
